import { RunTimelineMonth } from "@/components/RunTimeline.types";
import { RunForTimeline } from "@/stores/useRunCarouselStore";
import { TZDate } from "@date-fns/tz";
import { Timezone } from "@shared/lib/constants/timezones";
import { isSameDay, isSameMonth, parseISO, startOfMonth } from "date-fns";

export default function (runs: Array<RunForTimeline>, sort: "asc" | "desc" = "asc") {
  return [...runs].sort((a, b) => {
    return sort === "asc"
      ? +parseISO(a.start_at) - +parseISO(b.start_at)
      : +parseISO(b.start_at) - +parseISO(a.start_at);
  }).reduce<Array<RunTimelineMonth>>((acc, run, i) => {
    const prevItem = acc.at(-1);
    const prevDate = prevItem?.dates.at(-1);
    const date = getRunDate(run);

    if (i === 0 || prevDate && !isSameMonth(date, prevDate.date)) {
      acc.push({
        date: startOfMonth(date),
        dates: [
          {
            date,
            runs: [run],
          },
        ],
      });
    } else if (prevItem && prevDate && !isSameDay(date, prevDate.date)) {
      prevItem.dates.push({
        date,
        runs: [run],
      });
    } else if (prevDate) {
      prevDate.runs.push(run);
    }

    return acc;
  }, []);
}

function getRunDate (run: RunForTimeline) {
  return new TZDate(parseISO(run.start_at), run.court?.timezone || Timezone["America/New_York"]);
}
